import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-customer-base-card',
  templateUrl: 'customer-base-card.component.html',
  styleUrls: ['customer-base-card.component.css']
})

export class CustomerBaseCardComponent {

  @Input() current;
  @Input() change;
  @Input() previous;
  @Input() title;
  @Input() measurement_unit;
  @Input() measurement_unit_position = 'before';
  @Input() type = 'int';

  constructor() { }

  isNum(input: any): boolean {
    return !Number.isNaN(parseInt(input, 10) || parseFloat(input));
  }
}



// WEBPACK FOOTER //
// ./src/app/views/customerDB/customer-base/customer-base-card.component.ts